<template>
  <div class="warningTem flex_wrap">
    <div class="warningWrap" v-for="(item,index) in allWarning" :key="index">
      <img v-if="item.abnormal" class="warningImg" :src="item.activeIcon">
      <img v-else class="warningImg" :src="item.grayIcon">
      <p style="margin-top: 5px;">{{ $t(item.name) }}</p>
    </div>
  </div>
</template>

<script>
import { listWarningPushMsg2 } from '@/api/warning.js'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      allWarning: [
        {
          abnormal: false,
          key: 1,
          name: 'allDeviceDetail.lowPower',
          grayIcon: require('@/assets/images/warning/socLow_0.png'),
          activeIcon: require('@/assets/images/warning/socLow_1.png')
        }, // SOC低
        {
          abnormal: false,
          key: 7, name: 'allDeviceDetail.LowVoltage',
          grayIcon: require('@/assets/images/warning/voltageLow_0.png'),
          activeIcon: require('@/assets/images/warning/voltageLow_1.png')
        }, // 电压低
        {
          abnormal: false,
          key: 4, name: 'allDeviceDetail.HighTemperature',
          grayIcon: require('@/assets/images/warning/temperatureHeight_0.png'),
          activeIcon: require('@/assets/images/warning/temperatureHeight_1.png')
        }, // 温度高
        {
          abnormal: false,
          key: 2,
          name: 'table1.low_liquid',
          grayIcon: require('@/assets/images/warning/water_0.png'),
          activeIcon: require('@/assets/images/warning/water_1.png')
        }, // 液位低
        {
          abnormal: false,
          key: 5,
          name: 'table1.offline',
          grayIcon: require('@/assets/images/warning/offline.png'),
          activeIcon: require('@/assets/images/warning/offline_1.png')
        }, // 离线
        {
          abnormal: false,
          key: 15,
          name: 'warningInfo.HalfVWarnS',
          grayIcon: require('@/assets/images/warning/auxV_0.png'),
          activeIcon: require('@/assets/images/warning/auxV_1.png')
        }, // 半电压不均衡
        {
          abnormal: false,
          key: 6, name: 'allDeviceDetail.OutSettingArea',
          grayIcon: require('@/assets/images/warning/position_0.png'),
          activeIcon: require('@/assets/images/warning/position_1.png')
        }, // 不在设定区域
        {
          abnormal: false,
          key: 18, name: 'table1.data_service',
          grayIcon: require('@/assets/images/warning/data.png'),
          activeIcon: require('@/assets/images/warning/data_1.png')
        } // 数据服务到期
      ],
      reloadTimer: null
    }
  },
  computed: {
    mcuId () {
      return this.$route.query.mcuId
    }
    // language () {
    //   return this.$store.state.language
    // },
    // warningList () {

    //   const getIcon = (i, gray, yellow) => {
    //     const pre = '@/assets/images/warning/'
    //     const arr = this.statusArr
    //     if (arr[i]) {
    //       return pre + yellow + '.png'
    //     }else {
    //       return pre + gray + '.png'
    //     }
    //   }
    //   return [
    //     {type: 1, name: 'allDeviceDetail.lowPower', iconPath: require(getIcon(0, 'socLow_gray', 'socLow_color'))}
    //   ]
    // }
  },
  watch: {
    // warningList: {
    //   handler(newValue, oldValue) {
    //     this.warningList = newValue // 把新值赋值给我们的属性数据
    //     this.queryList() // 刷新
    //   },
    //   deep: true
    // },
    // language (newValue, oldValue) {
    //   this.getWarningList()
    // }
  },
  mounted () {
    // setTimeout(() => {
    this.getWarningList()
    // }, 50)
  },
  beforeDestroy () {
    clearTimeout(this.reloadTimer)
  },
  methods: {
    getWarningList () {
      clearTimeout(this.reloadTimer)
      this.reloadTimer = setTimeout(() => {
        this.getWarningList()
      }, 30000);
      listWarningPushMsg2({
        delFlag: 0,
        key: this.mcuId
      }).then(res => {
        console.log('warn-box 警告消息列表:', res)
        // 1 soc、2 电池液位、4温度高1、6电子围栏、7电压低、8温度低、9温度异常、10电压高、11温度高2、12温度高3、13温度高4、
        //15 半路电压告警、16 设备离线、18 数据服务有效期剩余1个月、19数据服务有效期已到期，-1全部
        if (res.resultCode == 1001 && res.resultModel) {
          this.allWarning.forEach(item => item.abnormal = false)
          const list = res.resultModel.list || []
          list.forEach(item => {
            if (item.msgType == 1) this.allWarning[0].abnormal = true
            if (item.msgType == 7) this.allWarning[1].abnormal = true
            if (item.msgType == 4 || item.msgType == 11 || item.msgType == 12 || item.msgType == 13) this.allWarning[2].abnormal = true
            if (item.msgType == 2) this.allWarning[3].abnormal = true
            if (item.msgType == 16) this.allWarning[4].abnormal = true
            if (item.msgType == 15) this.allWarning[5].abnormal = true
            if (item.msgType == 6) this.allWarning[6].abnormal = true
            if (item.msgType == 18 || item.msgType == 19) this.allWarning[7].abnormal = true
          })
        }
      })
      // getRealTimeInfo2({ sn: this.$route.query.sn }).then(res => {
      //   console.log('设备信息2，警告', res)
      //   if (!res.data) return
      // this.warningList = []
      // res.data.warning.forEach(v => {
      //   // 因为msgType=10/11/12/13是同一种警告
      //   if (v.msgType == 10 || v.msgType == 11 || v.msgType == 12 || v.msgType == 13) { v.msgType = 10 }
      //   if (this.warningList.indexOf(v.msgType) == -1) {
      //     if (v.msgType == 15) { // 半电压关闭时，半电压警告不显示
      //       if (this.batteryInfo.halfVOnOrOff == 1) this.warningList.push(v.msgType)
      //     } else {
      //       this.warningList.push(v.msgType)
      //     }
      //   }
      // })
      // this.warningList = [...new Set(this.warningList)]// 去重
      // this.queryList()
      // })

    },
    queryList () {

      console.log('warningList======', this.warningList)
      this.allWarning.forEach((v, i) => { // 图片名字国际化
        switch (v.key) {
          case 1: this.allWarning[i].name = this.$t('allDeviceDetail.lowPower'); break
          case 4: this.allWarning[i].name = this.$t('allDeviceDetail.HighTemperature'); break
          case 5: this.allWarning[i].name = this.$t('allDeviceDetail.SOHBad'); break
          case 6: this.allWarning[i].name = this.$t('allDeviceDetail.OutSettingArea'); break
          case 7: this.allWarning[i].name = this.$t('allDeviceDetail.LowVoltage'); break
          case 'overDischarged': this.allWarning[i].name = this.$t('allDeviceDetail.Overdischarge'); break
          case 15: this.allWarning[i].name = this.$t('warningInfo.HalfVWarnS'); break
          case 'hardwareFailure': this.allWarning[i].name = this.$t('allDeviceDetail.hardwareMalfunction'); break
        }
        // this.allWarningKey.push(v.key)
      })
      // remainWarn = JSON.parse(JSON.stringify(this.allWarning))
      // this.allWarning.forEach((v, i) => {
      //   this.warningList.forEach(m => {
      //     if (m == v.key) {
      //       realyWarn.push(this.allWarning[i])
      //       remainWarn.splice(i, 1)// 减掉实际警告
      //     }
      //   })
      // })

      // this.warningList.forEach(v => {//真实警告
      var newAllWarn = [...this.allWarning]
      console.log('newAllWarn:', newAllWarn)
      // newAllWarn.forEach((v, i) => { // 图片名字国际化
      //   if (this.warningList.indexOf(v.key) > -1) {
      //     switch (v.key) {
      //       case 1: v.imgUrl = require('@/assets/images/warning/socLow_color.png'); break
      //       case 2: v.imgUrl = require('@/assets/images/warning/water_color.png'); break
      //       case 4: v.imgUrl = require('@/assets/images/warning/temperatureHeight_color.png'); break
      //       case 5: v.imgUrl = require('@/assets/images/warning/soh_color.png'); break
      //       case 6: v.imgUrl = require('@/assets/images/warning/position_color.png'); break
      //       case 7: v.imgUrl = require('@/assets/images/warning/voltageLow_color.png'); break
      //       case 8: v.imgUrl = require('@/assets/images/warning/temLow_color.png'); break
      //       case 9: v.imgUrl = require('@/assets/images/warning/temAbnormal_color.png'); break
      //       case 10: v.imgUrl = require('@/assets/images/warning/voltageHeight_color.png'); break
      //       case 'overDischarged': v.imgUrl = require('@/assets/images/warning/overDischarged_color.png'); break
      //       case 15: v.imgUrl = require('@/assets/images/warning/auxV_color.png'); break
      //       case 'hardwareFailure': v.imgUrl = require('@/assets/images/warning/hardwareFailure_color.png'); break
      //     }
      //   }
      // })

      this.warningList1 = newAllWarn.slice(0, 4)
      this.warningList2 = newAllWarn.slice(4, 8)
    }
  }
}
</script>

<style lang="scss">
.warningTem {
  overflow: hidden;
  .warningWrap {
    font-size: 14px;
    width: 25%;
    text-align: center;
    padding-top: 30px;
  }
  .warningDivs {
    // display: inline-block;
    // width: 25%;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // width: 105px;
    // min-width: 105px;
    // white-space: normal;
    // word-break: break-all;
    // word-wrap: break-word;
    p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .warningImg {
    width: 70px;
    height: 70px;
    display: inline-block;
  }
}
</style>

